module.exports = __webpack_public_path__ + "static/media/platforms.629b4ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/platforms.png
// module id = 63
// module chunks = 0